module.exports = __webpack_public_path__ + "static/media/multiplayer.af26ca4c.png";